/**
 * Get user initials from a full name string
 * @param name - The full name string
 * @returns The initials as a string (e.g., "John Doe" -> "JD")
 */
export function getInitials(name: string): string {
  if (!name || typeof name !== 'string') {
    return '';
  }
  
  return name
    .trim()
    .split(' ')
    .filter(word => word.length > 0) // Filter out empty strings from multiple spaces
    .map(word => word.charAt(0).toUpperCase())
    .join('')
    .slice(0, 2); // Limit to 2 characters for better display
}